import api from '@disco/api/server'
import { copyToDisco } from '@disco/state-management/actions/ExplorerActions'
import { loadBatch } from '@disco/state-management/actions/PlaylistTrackActions'
import { getGroupsWithNesting } from '@disco/state-management/selectors/groups'
import { getTrack } from '@disco/state-management/selectors/tracks'

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useParams, useNavigate } from 'react-router-dom'
import type { GroupId } from 'types/group'
import type { TrackId } from 'types/track'
import AddToChannelModal from 'components/common/custom-libraries/add-to-channel'
import DocumentHeadTags from 'components/document-head-tags'

const CopyToChannel = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams<{ trackId: string; originGroupId: string }>()
  const trackId = parseInt(params.trackId!)
  const originGroupId = parseInt(params.originGroupId!)
  const track = useSelector(state =>
    getTrack(state, {
      id: trackId,
    }),
  )
  const groups = useSelector(getGroupsWithNesting)

  const handleClose = () => navigate('/')

  useEffect(() => {
    // fetch track details if we track playlists were not loaded previously
    if (track) return
    api
      .getTrack(trackId)
      .then(track => dispatch(loadBatch([track])))
      .catch(() => {})
  }, [track, trackId, dispatch])

  const handleAddToGroup = async groupsToAdd => {
    if (!track) return
    const objectUrl = track.stream_url
    const groupIds = groupsToAdd.map(groupToAdd => groupToAdd.value)
    dispatch(
      copyToDisco(
        track.name,
        objectUrl,
        {
          groupIds,
        },
        originGroupId,
      ),
    )
    handleClose()
  }

  return (
    <>
      <DocumentHeadTags title="Copy to channel | DISCO" />
      <AddToChannelModal
        type="copy"
        groups={groups}
        source={track}
        onSubmit={handleAddToGroup}
        onClose={handleClose}
      />
    </>
  )
}

export default CopyToChannel
